export const newsList = [
  {
    id: "news-restored-2026",
    title: "《蜜桃成熟时》4K 修复版重映：三十年后，我们为何仍在谈论它",
    category: "专题",
    date: "2026-09-18",
    author: "编辑部",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20amber%20cinema%20projector%20beam%20in%20a%20dark%20theater%2C%20dust%20particles%20in%20the%20light%2C%20empty%20red%20velvet%20seats%2C%20nostalgic%20film%20restoration%20atmosphere%2C%20soft%20peach%20highlights&width=800&height=600&seq=news-restored-2026&orientation=landscape",
    summary:
      "时隔三十余年，系列首作以 4K 修复版本重新回到大银幕。修复团队与影评人一起，聊聊胶片质感为何无法被替代。",
    content: [
      {
        text: "今年秋天，系列首作的 4K 修复版在多地展开限定重映。与首轮放映相隔三十余年，这次重映让不少年轻观众第一次在影院里看到这部作品。",
      },
      {
        heading: "一次关于质感的修复",
        text: "修复团队介绍，原底片存在不同程度的划痕与褪色，尤其是夜景部分偏色明显。团队以原始胶片扫描为基础，逐帧处理损伤，同时刻意保留了颗粒结构。",
      },
      {
        text: "「我们不想把它修成一部新片。」修复负责人在映后交流中说，「颗粒本身就是那个年代的表演方式的一部分，抹掉它，人物的呼吸感也没了。」",
      },
      {
        heading: "为什么仍然值得讨论",
        text: "重映之后，关于影片的讨论集中在两件事：一是九十年代香港都市电影对日常细节的耐心，二是它在类型标签之外的情感表达。",
      },
      {
        text: "多位影评人指出，影片真正的价值不在话题性，而在于它把一个普通女孩的犹疑拍得足够诚实。这种诚实，在任何年代都不会过时。",
      },
      {
        heading: "后续放映计划",
        text: "据主办方介绍，修复版还将在数个城市进行学术放映，并配套主创访谈与胶片工作坊。具体场次可关注本站后续资讯。",
      },
    ],
    relatedMovies: ["peach-1993", "peach-2023"],
  },
  {
    id: "news-genre-history",
    title: "从都市青春到类型记忆：《蜜桃成熟时》系列的影像谱系",
    category: "评论",
    date: "2026-08-30",
    author: "陈默",
    cover:
      "https://readdy.ai/api/search-image?query=overhead%20shot%20of%20scattered%20vintage%20film%20stills%20and%20contact%20sheets%20on%20a%20warm%20wooden%20desk%2C%20amber%20desk%20lamp%2C%20nostalgic%20archive%20research%20mood%2C%20soft%20shadows&width=800&height=600&seq=news-genre-history&orientation=landscape",
    summary:
      "把系列放回香港类型片的历史脉络中，会发现它记录的从来不只是个人情感，还有一座城市观看自己的方式。",
    content: [
      {
        text: "讨论这个系列，容易停留在标签层面。但如果把八部作品按时间排开，会看到一条相当清晰的线索：都市空间如何改变人物的情感表达。",
      },
      {
        heading: "九十年代：街道作为舞台",
        text: "早期的作品大量使用真实街景，便利店、天台、旧式电梯反复出现。镜头很少刻意美化空间，反而让杂乱的环境成为人物情绪的一部分。",
      },
      {
        heading: "重启之后：从街道到屏幕",
        text: "2011 年的重启作把叙事搬进了影像与记忆之中，空间从实体街道转向屏幕内部。这一转变恰好对应了观众观看方式的改变。",
      },
      {
        text: "近年的新作又重新回到实景，但这一次的街道已经带着被记录、被怀念的属性。系列因此形成了一种自我回望的结构。",
      },
      {
        heading: "一条值得继续写下去的线索",
        text: "对于类型研究者而言，这个系列提供了一个观察香港都市电影工业变化的样本：制作规模、演员构成、发行方式的变化，都能在片目里找到痕迹。",
      },
    ],
    relatedMovies: ["peach-1997", "peach-2011", "peach-2025"],
  },
  {
    id: "news-loletta-interview",
    title: "李丽珍谈《蜜桃成熟时》：那是一次关于成长的表演",
    category: "新闻",
    date: "2026-08-12",
    author: "林一",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20intimate%20interview%20setting%20with%20two%20chairs%20and%20a%20small%20table%20near%20a%20sunlit%20window%2C%20sheer%20curtains%2C%20soft%20peach%20light%2C%20editorial%20photography%2C%20quiet%20reflective%20mood&width=800&height=600&seq=news-loletta-interview&orientation=landscape",
    summary:
      "在修复版重映的映后交流中，李丽珍回顾了当年的拍摄经历，并谈了自己对「标签」与「表演」的看法。",
    content: [
      {
        text: "映后交流持续了将近一小时。谈到最初接到角色时，李丽珍说，自己当时最在意的并不是影片的类型，而是人物有没有真实的犹豫。",
      },
      {
        heading: "「她不是一个符号」",
        text: "她提到，开拍前自己写了一整本人物小传，包括阿桃喜欢吃什么、坐哪一路巴士、和母亲说话时会用什么语气。「这些不会出现在镜头里，但我知道。」",
      },
      {
        text: "对于外界多年来的各种标签，她的回应很平静：「标签是别人方便的记忆方式，但演员要做的是让角色站得住。站得住，标签就只是标签。」",
      },
      {
        heading: "关于重看自己的表演",
        text: "她说自己已经很久没有完整看过这部片子，这次在大银幕上重看，反而注意到了很多当年没有意识到的细节。「那时候的紧张是真的，现在看还挺可爱。」",
      },
    ],
    relatedMovies: ["peach-1993", "peach-2023"],
  },
  {
    id: "news-city-diary-wrap",
    title: "系列新作《城市日记》杀青，主创分享幕后创作",
    category: "新闻",
    date: "2026-07-26",
    author: "本站记者",
    cover:
      "https://readdy.ai/api/search-image?query=film%20crew%20celebrating%20wrap%20on%20a%20city%20rooftop%20at%20dusk%2C%20warm%20orange%20sky%2C%20camera%20equipment%20silhouettes%2C%20documentary%20style%20photography%2C%20warm%20peach%20tones&width=800&height=600&seq=news-city-diary-wrap&orientation=landscape",
    summary:
      "《蜜桃成熟时·城市日记》近日完成全部拍摄。导演陈小娟与主演陈静分享了影片的创作起点与拍摄方式。",
    content: [
      {
        text: "影片大部分场景在旧区实景拍摄，剧组采用小规模班底，以减少对街区日常的干扰。",
      },
      {
        heading: "从一个真实的拆迁现场开始",
        text: "导演陈小娟表示，最初的灵感来自一次勘景。「我们在一条即将清拆的街道上遇到一位正在拍DV的阿姨，那一刻我觉得这个故事已经有了。」",
      },
      {
        text: "为了让纪录片导演这一职业更可信，主演陈静跟随一位真实的纪录片工作者工作了近一个月，参与素材整理与剪辑会议。",
      },
      {
        heading: "后期与上映",
        text: "影片目前进入后期制作阶段，预计将在明年上半年与观众见面。",
      },
    ],
    relatedMovies: ["peach-2025", "peach-2023"],
  },
  {
    id: "news-restoration-craft",
    title: "幕后全纪录：修复团队如何还原九十年代的胶片质感",
    category: "专题",
    date: "2026-07-05",
    author: "技术组",
    cover:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20a%20film%20scanner%20and%20color%20grading%20monitors%20in%20a%20warm%20dim%20studio%2C%20amber%20light%2C%20technical%20restoration%20workspace%2C%20cinematic%20detail%20photography&width=800&height=600&seq=news-restoration-craft&orientation=landscape",
    summary:
      "从 35 毫米底片扫描到逐帧校色，修复一部三十年前的电影要经过哪些步骤？我们走进修复工作室。",
    content: [
      {
        text: "修复工作室位于一栋旧工业大厦内。恒温恒湿的片库里，整齐码放着金属片盒，其中一只标签已经泛黄。",
      },
      {
        heading: "第一步：物理清洁与扫描",
        text: "底片先进行手工清洁，再以高分辨率逐帧扫描。工作人员介绍，扫描阶段最重要的不是分辨率数字，而是保持原始的动态范围，为后期保留信息。",
      },
      {
        heading: "第二步：稳定与去损",
        text: "早期胶片的画面抖动与划痕需要逐帧处理。团队开发了一套半自动流程，但关键镜头仍由人工判断，避免过度修复导致画面「发塑料」。",
      },
      {
        heading: "第三步：校色",
        text: "校色以当年冲印的拷贝为参考。「我们会问自己，这个橙色在记忆里应该是什么样。」调色师说。",
      },
      {
        text: "整个修复过程历时十一个月。最终版本在保留颗粒与轻微柔化的同时，让暗部层次重新回到画面里。",
      },
    ],
    relatedMovies: ["peach-1993", "peach-1997", "peach-2023"],
  },
  {
    id: "news-classic-scenes",
    title: "影迷票选：系列十大经典桥段公布",
    category: "新闻",
    date: "2026-06-21",
    author: "影迷社区",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cinema%20lobby%20with%20framed%20movie%20stills%20on%20the%20wall%2C%20amber%20lighting%2C%20vintage%20ticket%20booth%2C%20nostalgic%20welcoming%20atmosphere%2C%20soft%20peach%20tones&width=800&height=600&seq=news-classic-scenes&orientation=landscape",
    summary:
      "为期三周的影迷投票结束，天台对话、雨夜长街、桃花初开等段落进入前十。",
    content: [
      {
        text: "本次投票共收到有效问卷超过两万份，参与者在八部系列作品中选出自己印象最深的段落。",
      },
      {
        heading: "前三名",
        text: "第一名是首作结尾的清晨长街镜头，第二名是《夏日回声》的天台长镜头，第三名是《蜜桃仙子》中桃花初开的段落。",
      },
      {
        text: "不少参与者在开放题里写道，自己记住的不是情节，而是某一种光线、某一段沉默。",
      },
      {
        heading: "一个小发现",
        text: "统计显示，二十五岁以下观众对近年作品的偏好明显更高，而三十五岁以上观众更倾向于九十年代的作品。",
      },
    ],
    relatedMovies: ["peach-1993", "peach-2024", "peach-1999"],
  },
  {
    id: "news-academic-view",
    title: "学术视角：香港都市电影中的青春叙事",
    category: "评论",
    date: "2026-06-02",
    author: "周予安",
    cover:
      "https://readdy.ai/api/search-image?query=stack%20of%20film%20studies%20books%20and%20a%20notebook%20on%20a%20warm%20wooden%20table%2C%20afternoon%20light%20through%20a%20window%2C%20soft%20peach%20and%20cream%20tones%2C%20quiet%20scholarly%20atmosphere&width=800&height=600&seq=news-academic-view&orientation=landscape",
    summary:
      "当青春不再只是年龄，而是一种城市经验，这类影片的叙事方式也随之改变。一篇关于空间与成长的观察。",
    content: [
      {
        text: "在关于成长的研究里，空间经常被视为背景。但对于香港电影而言，空间常常直接参与叙事。",
      },
      {
        heading: "狭窄空间里的关系",
        text: "电梯、走廊、天台，这些半公共的空间让角色既靠近又无法完全袒露。影片中的许多关键对话，都发生在这样的缝隙里。",
      },
      {
        heading: "移动与停留",
        text: "人物的成长往往通过移动完成：搬家、换工作、离开某条街。镜头对移动的处理方式，构成了影片对「长大」的理解。",
      },
      {
        text: "从这个角度看，系列的价值不仅在于记录了某个年代，更在于持续提供了一种把私人情绪与城市经验放在一起讨论的方式。",
      },
    ],
    relatedMovies: ["peach-2005", "peach-2025"],
  },
];